import { ReactElement, ReactNode } from 'react';

import { colorsMatrix, DarkTheme, DrErykTheme, StandardTheme, ThemeProvider } from '@dreryk/react-components';

const AdamedExpertTheme: DrErykTheme = {
   ...StandardTheme,
   primary: '#799BD9',
   primaryDark: '#589AE9',
   secondary: '#589AE9',
   backgroundBody: '#144089',
   border: '#799BD9',
   textBody: colorsMatrix.grey.lightest,
   errorDarker: colorsMatrix.red.lighter,
   errorDark: colorsMatrix.red.light,
   error: colorsMatrix.red.basic,
   errorLight: colorsMatrix.red.basic,
   errorLighter: colorsMatrix.red.dark,
   errorLightest: colorsMatrix.red.darker,
};

const AdamedExpertDarkTheme: DrErykTheme = {
   ...DarkTheme,
   primary: AdamedExpertTheme.primary,
   primaryDark: AdamedExpertTheme.primaryDark,
   secondary: AdamedExpertTheme.secondary,
   border: AdamedExpertTheme.border,
   backgroundBody: AdamedExpertTheme.backgroundBody,
   backgroundInput: AdamedExpertTheme.backgroundInput,
   textInput: AdamedExpertTheme.textInput,
   buttonText: AdamedExpertTheme.buttonText,
};

type AdamedExpertThemeProviderProps = {
   readonly children: ReactNode;
};

export const AdamedExpertThemeProvider = (props: AdamedExpertThemeProviderProps): ReactElement => {
   return (
      <ThemeProvider light={AdamedExpertTheme} dark={AdamedExpertDarkTheme}>
         {props.children}
      </ThemeProvider>
   );
};
